module.exports = __webpack_public_path__ + "static/media/banner-2.06477820.jpg";